import { observer } from 'mobx-react-lite'

import { Logo } from './Logo'

export const AppHeaderLogo = observer(function AppHeaderLogo() {
  return <Logo size='small' />
})
